import { useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({
    qrCode: {
        padding: '1em',
        [theme.breakpoints.only('xs')]: {
            height: '40vh',
        },
        [theme.breakpoints.only('sm')]: {
            height: '40vh',
        },
        [theme.breakpoints.only('md')]: {
            height: '43vh',
        },
        [theme.breakpoints.only('lg')]: {
            height: '45vh',
        },
        [theme.breakpoints.only('xl')]: {
            height: '50vh',
        },
    },

    footer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },

    footerText: {
        color: theme.palette.secondary.main,
        fontSize: 12
    },

    qrContent: {
        marginTop: theme.spacing(2),
        width: '60%',
        height: '90vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        ['@media only screen and (max-width: 600px)']: {
            width: '100%',
        },
    },

    loadingQrContent: {
        marginTop: theme.spacing(2),
        width: '100%',
        height: '80vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        ['@media only screen and (max-width: 600px)']: {
            width: '100%',
        },
    },


    titleSection: {
        ['@media only screen and (max-width: 600px)']: {
            height: '25%',
            width: '80%',
        },
    },

    qrCodeSection: {
        ['@media only screen and (max-width: 600px)']: {
            height: '75%',
            width: '100%',
            backgroundColor: theme.palette.secondary.light,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
    },

    footerlogo: {
        height: '59px',
        width: '68px',
        marginBottom: theme.spacing(1)
    },

    imageSection: {
        height: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ['@media only screen and (max-width: 600px)']: {
            marginTop: theme.spacing(3)
        },
    },

    img: {
        marginTop: theme.spacing(4),
        height: '100%'
    }
}))